import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {
	catchError,
	distinctUntilChanged,
	map,
} from 'rxjs/operators';

import { Observable, of } from 'rxjs';

import { UnsubscribeOnDestroyExtension } from '@rs-bank/rs-core';
import { unsubscribeOnDestroy } from '@rs-bank/rs-rxjs-extention';

import { IbCoreCommonUtils } from 'ib/internetbank-core/utils/ib-common-utils';


import { ProductTypes } from '../../../../common/models/product-types';
import { Product } from '../../../products.model';
import { ProductsService } from '../../../products.service';

import { CardStatusList } from './../../../../common/models/card-status-list';

@Injectable({ providedIn: 'root' })
export class ProductSliderService extends UnsubscribeOnDestroyExtension {

	public productList: Observable<Array<Product>>;

	constructor(public router: Router, public productsService: ProductsService) {
		super();
		this.productList = this.productsService
			.productsWithBalancesAndBonusesList$
			.pipe(
				distinctUntilChanged((prev: Array<Product>, curr: Array<Product>) => IbCoreCommonUtils.isArraysEqual<Product>(prev, curr)),
				map((products: Array<Product>) => products.filter((product: Product) => !!product)),
				catchError(() => of([])),
				unsubscribeOnDestroy(this),
			);
	}


	public filteredProducts(products: Array<Product>): Array<Product> {
		if (!products) {
			return [];
		}

		const _products: Array<Product> = products
			.filter((product: Product) => !!product)
			.filter(
				(product: Product) => {
					const cardStatusList: Array<CardStatusList> = product.balanceInfo?.cardStatusList || [];

					if (product.productId) {
						switch (product.productId.productType) {

							case ProductTypes.EXTERNALCARD:
								return false;
							case ProductTypes.CARD:
								return (cardStatusList &&
									cardStatusList.some((item: CardStatusList) => (
										item === 'ACTIVE' ||
										item === 'UNKNOWN'
									)));
							default: return true;
						}
					}

					return (
						cardStatusList &&
						cardStatusList.some((item: CardStatusList) => item === 'ACTIVE')
					);
				});

		return _products;
	}

	public sliderItemClick = (item: Product): void => {
		if (!(item && item.productId)) {
			this.router.navigate(['/404']);
			return;
		}

		// у неподлюкченной бонусной программы нет детальной инфы
		if (item.productId.productType === ProductTypes.BONUS && !item.balance?.active) {
			return;
		}

		const productType: string | undefined = item.productId.productType?.toLocaleLowerCase();
		const link: string = this.generateProductLink(item);
		if (productType && link) {
			const mainUrl: string = productType === ProductTypes.BONUS.toLocaleLowerCase()
				? 'bonus'
				: productType;

			this.router.navigate([
				'/',
				mainUrl,
				link,
			]);
			return;
		}

		this.router.navigate(['/main']);
	};

	private generateProductLink(item: Product): string {
		if (item.productId?.productType === ProductTypes.BONUS) {
			return item.programId;
		} else {
			return `${item.productId?.getSimpleId()}`;
		}
	}

}
